/**
 * The header's dark-glass surface. Header.tsx and the brand card's copy of the
 * header (XC-ERP1-U11 §2.1) both use it, so the preview a customer judges a
 * logo's contrast by never drifts from the real header.
 */
export const HEADER_SURFACE_CLASS =
  'bg-gradient-to-r from-black/40 via-black/25 to-black/40 backdrop-blur-2xl';
